import { useContext } from 'react'
import {Routes as Router, Route, Navigate, Outlet} from 'react-router-dom'
import { AuthContext } from './context/AuthContext'
import Home from './pages/home/Home'
import PreOrder from './pages/preorder/PreOrder'
import Login from './pages/login/Login'
import { useAuthentication } from './common/requests/LoginRequest'
import ClientPreOrder from './pages/clientPreorder/ClientPreOrder'
import ClientPreOrderSuccess from './pages/clientPreorder/ClientPreOrderSuccess'

type Props = {}

const PrivateRoutes = () => {
  const { authenticated } = useContext(AuthContext)
  const authentication = useAuthentication();

  if(!authenticated && !authentication.isAuthenticated) return <Navigate to='/login' replace />

  return <Outlet />
}

const Routes = (_props: Props) => {
  return (
    <Router>
      <Route element={<PrivateRoutes />}>
            <Route path='/' element={<Home/>}/>
        </Route>

        <Route element={<PrivateRoutes />}>
            <Route path='/preorder' element={<PreOrder/>}>
            <Route path=":id" />
            </Route>
        </Route>

        <Route path='/login' element={<Login/>} />

        <Route path='/svc' element={<ClientPreOrder/>}/>
        <Route path='/svc/success' element={<ClientPreOrderSuccess/>}/>
    </Router>
  )
}

export default Routes